import React, { Fragment } from "react"
import "typeface-open-sans"

import { GlobalStyle, StyledLayout } from "./style"

import Navbar from "../NavBar"
import Footer from "../Footer"
import Header from "../Header"

class Layout extends React.Component {
  render() {
    const { children, title, subtitle } = this.props

    return (
      <Fragment>
        <GlobalStyle />
        <Navbar />
        <Header title={title} subtitle={subtitle} />
        <StyledLayout>{children}</StyledLayout>
        <Footer />
      </Fragment>
    )
  }
}

export default Layout
